import { createFileRoute } from '@tanstack/react-router';
import { CmsPageRenderer } from '@pages/cms-page';

/** Route für die Vereinsseite (/verein). Lädt CMS-Inhalte für Slug "verein". */
export const Route = createFileRoute('/verein/')({
  component: function VereinRoute() {
    return <CmsPageRenderer slug="verein" />;
  },
});
